import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect, ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import type WritingLegendsCourseProgressController from 'teacher-ui-client/reporting/ui-scope/writing-legends/course-progress/controller'
import type WritingLegendsCourseProgressRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/course-progress/route'
import { CourseProgressTotalsReportLoader } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/totals/report-loader'
import { CourseProgressAveragesReportLoader } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/averages/report-loader'
import { CourseProgressHistoryReportLoader } from 'teacher-ui-client/components/reporting/writing-legends/course-progress/history/report-loader'
import { array } from '@ember/helper'
import { hash } from '@ember/helper'
import type { TOC } from '@ember/component/template-only'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsCourseProgressRoute>
    controller: WritingLegendsCourseProgressController
  }
}

export const WritingLegendsCourseProgressPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.lessonCourseProgress"}} />
  <ReportingControls>
    <ReportingUiScopeSelect class="shrink basis-80" />
    <ReportingControlsGap />
    <ReportingPeriodSelect />
    <ReportingControlsGap />
    <ReportingExportSelect @exportOptions={{array (hash exportType=ExportType.print)}} />
  </ReportingControls>
  <div class="space-y-4">
    <CourseProgressTotalsReportLoader @uiScope={{@model.uiScope}} @period={{@model.period}} />
    <CourseProgressAveragesReportLoader @uiScope={{@model.uiScope}} @period={{@model.period}} />
    <CourseProgressHistoryReportLoader
      @uiScope={{@model.uiScope}}
      @period={{@model.period}}
      @sort={{@controller.sort}}
      @pageNumber={{@controller.pageNumber}}
      @perPage={{@controller.perPage}}
    />
  </div>
</template>

export default RouteTemplate(WritingLegendsCourseProgressPage)
